import React from 'react'
import { Box } from '@mui/material'
import { AppButtonIcon, AppCardTitle } from '@components'


export default function AnalyzerCategoriesTableToolbar({ setFullScreen, isFullScreen }) {

    // In fullscreen the dialog header carries the title and the close button.
    if (isFullScreen) return null

    return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', mb: 1.5 }} >
        <AppCardTitle icon="layer-group" title="Price Table sorted by Categories"/>
        <AppButtonIcon icon='expand-wide' tooltip='Fullscreen' iconWeight='solid' onClick={setFullScreen}  />
    </Box>
}
